<template>
    <div>
        
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">Penerimaan QR</h2>
            </div>
            <div class="p-2 bd-highlight" style="width: 150px;">
                <div class="row"> 
                    <div class="col-12 mt-auto mb-auto">
                        Saldo QR : {{ saldoQr === 0 ? 0 : (saldoQr ? numberWithCommas(saldoQr) : 'Loading...') }}
                    </div>
                    <!-- <div class="col-7">
                        <button class="btn shadow w-100 bg-white">
                            <i class="fa fa-file-pdf">&nbsp; Download Template</i>
                        </button>
                    </div> -->
                </div>
            </div>
        </div>


        <qr-receipt-from-qtrust
            class="mt-4"
        ></qr-receipt-from-qtrust>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import qrReceiptFromQtrust from './children/qrReceiptFromQtrustTable.vue'

export default {
    metaInfo : {
        title : 'QR Issue'
    },
    components : {
        Multiselect,
        qrReceiptFromQtrust
    },
    data () {
        let startDate = moment().startOf('month').format("MM-DD-Y");
        let currentDate = moment().format("MM-DD-Y");
        return {
            rangePickr: {
                mode: 'range',
                dateFormat: "m-d-Y",
                altInput: true,
                altInputClass: 'form-control input bg-white h-47px',
                altFormat : 'm-d-Y'
            },
            selected : {
                date : `${startDate} to ${currentDate}`
            },
            saldoQr : null,
        }
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    mounted () {
        this.fetchData();
    },
    methods : {
        fetchData() {
            this.$http.get(`/api/qrs/highlight`)
            .then((resp)=>{
                this.saldoQr = resp.data.data.qty_after
            })
            .catch((err)=>{console.log(err)})
        },
    },
}
</script>

<style>
    .mpm-button {
        background-color :#F36F21 !important;
        color : white;
        height: 47px;
    }

    .mpm-button-outline {
        background-color :white !important;
        color : #F36F21;
        height: 47px;
    }

    .h-47px {
        height: 47px;
    }
</style>